import Vue from 'vue'
import router from '@/router'
import store from './store'
import EventBus from '@/EventBus'

Vue.config.productionTip = false
Vue.use(require('vue-shortkey'), {
  prevent: ['input', 'textarea']
})
Vue.use(require('vee-validate'))

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: () => EventBus
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<router-view></router-view>'
})



// WEBPACK FOOTER //
// ./src/main.js